// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/" + chunkId + "." + chunkId + "." + {"1378": "37ef96ff4092","2723": "4254ae83d63f","3245": "7f489da46fc5","4522": "e099e12f514c","5967": "88e5bd9a612e","6414": "27a38922b170","8844": "dadd586e1778",}[chunkId] + ".css"
}